import { z } from 'zod'
import { baseEntitySchema } from '../entity.js'
import { searchFilterSchema, searchRequestSchema } from '../search.js'

export const searchFolderSchema = baseEntitySchema.extend({
  type: z.literal('searchfolder'),
  query: searchRequestSchema,
  // The query is typically built from the queryString and queryFilter
  queryString: z.string().optional(),
  queryFilter: searchFilterSchema.optional(),
})

export type SearchFolder = z.infer<typeof searchFolderSchema>

export function isSearchFolder(node: unknown): node is SearchFolder {
  return searchFolderSchema.safeParse(node).success
}
